import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { useAppDispatch, useAppSelector } from "../../../../../lib/redux/hooks"
import { colors } from "../../../../../ui/colors"
import { ArrowLeftIcon } from "../../../../../ui/icons/arrow-left"
import { Layout } from "../../../../../ui/layout"
import { ButtonComponent } from "../../../../../ui/molecules/button/newButton"
import { MenuItems } from "../../../../../ui/organisms/navbar/dto"
import { MeasureStatusEnum } from "../../dataService/dto"
import { NewMeasureUpdate, resetNewMeasureUpdateStatus } from "../../slice"
import { AddNewCodexMeasureStep2Forms } from "./forms"
import { AddNewCodexMeasureStep2Right } from "./right"

export function AddNewCodexMeasureStep2() {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const sessionState = useAppSelector(state => state.session)
    const newMeasureState = useAppSelector(state => state.newMeasure)
    const [showSuccess, setShowSuccess] = useState<boolean>(false)

    useEffect(() => {
        if (newMeasureState.newMeasureUpdateStatus === 'successfully') {
            dispatch(resetNewMeasureUpdateStatus()); setShowSuccess(true)
        }
    }, [newMeasureState.newMeasureUpdateStatus])

    useEffect(() => {
        if (showSuccess) {
            setTimeout(() => { setShowSuccess(false); navigate('/provvedimentiCliente') }, 2000)
        }
    }, [showSuccess])

    return (
        <Layout
            menuItem={MenuItems.GESTIONE_PROVVEDIMENTI}
            breadcrumbItems={['Gestione Provvedimenti', 'Inserimento Nuovo Provvedimento Cliente']}
            headerLabel="Nuovo Provvedimento"
            customerName={sessionState.selected.customerName ?? undefined}
            customerCode={sessionState.selected.customerCode ?? undefined}
            rightBar={true}
            headerIcon={<ArrowLeftIcon onClick={() => navigate('/provvedimentiCliente')} color={colors.white} />}
            headerChildren={
                <div className="flex items-center h-[100%] w-[100%] justify-end">
                    <ButtonComponent
                        size="sm"
                        iconPosition="off"
                        variant="solid"
                        label="Salva"
                        color="orange"
                        onClick={() => dispatch(NewMeasureUpdate({ body: newMeasureState.newMeasureUpdateRequest, id: newMeasureState.newMeasureIdToUpdate }))}
                    />
                    <ButtonComponent
                        size="sm"
                        iconPosition="off"
                        variant="solid"
                        label="Salva e Chiudi"
                        color="red"
                        onClick={() => dispatch(NewMeasureUpdate({
                            body: { ...newMeasureState.newMeasureUpdateRequest, status: MeasureStatusEnum.CHIUSO },
                            id: newMeasureState.newMeasureIdToUpdate
                        }))}
                    />
                </div>
            }
            onScrollTop={newMeasureState.newMeasureUpdateStatus === 'successfully'}
        >
            {showSuccess && (
                <div className="mx-6 mt-6 rounded-xl border-2 border-green-300 bg-green-50 px-6 py-4">
                    <span className="text-sm font-semibold text-green-700">Dati salvati correttamente.</span>
                </div>
            )}
            <div className="flex min-h-screen">
                <div className="flex-[0.65]">
                    <AddNewCodexMeasureStep2Forms />
                </div>
                <div className="flex-[0.35] bg-brandPrimary-100 border-l border-neutral-200">
                    <AddNewCodexMeasureStep2Right />
                </div>
            </div>
        </Layout>
    )
}